// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__2iN2Y","title":"styles_title__cccB3","description":"styles_description__AWO9g"};